export enum Permissions {
  PLAY = "PLAY",
  EDIT_USER = "EDIT_USER",
  DELETE_USER = "DELETE_USER",
  CREATE_USER = "CREATE_USER",
  CREATE_SEASON = "CREATE_SEASON",
  EDIT_SEASON = "EDIT_SEASON",
  DELETE_SEASON = "DELETE_SEASON",
}

export enum AuthType {
  EMAIL = "EMAIL",
}

export interface UserDto {
  id: string;
  username: string;
  email: string;
  permissions: Permissions[];
  active: boolean;
  authType: AuthType;
  emailIsConfirmed: boolean;
  goldCapss: number;
  sparks: number;
}


export interface UserCreateRequest {
  name: string;
  surname: string;
  email: string;
  role: string[];
  password: string;
  active: boolean;
}